export default __webpack_public_path__ + "static/media/LogoZoom2.f48e3842.png";